import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    successTitle: {
        id: 'notifications.withdraw.success.title',
        defaultMessage: 'Successful send',
    },
    successContent: {
        id: 'notifications.withdraw.success.content',
        defaultMessage: 'Amount:',
    },
    pendingTitle: {
        id: 'notifications.withdraw.pending.title',
        defaultMessage: 'Send is pending',
    },
    pendingContent: {
        id: 'notifications.withdraw.pending.content',
        defaultMessage: 'Confirming the send transaction, please wait.',
    },
    errorTitle: {
        id: 'notifications.withdraw.error.title',
        defaultMessage: 'Error send',
    },
    errorContent: {
        id: 'notifications.withdraw.error.content',
        defaultMessage: 'The send transaction cannot be completed.',
    },
    errorButton: {
        id: 'notifications.withdraw.error.button',
        defaultMessage: 'Try again',
    },
    forbiddenApiError: {
        id: 'notifications.withdraw.error.forbidden.api',
        defaultMessage: 'The action was blocked <br/>Please contact support',
    },
    frozenError: {
        id: 'notifications.withdraw.error.frozen',
        defaultMessage: 'Withdrawals are not allowed due to whitelist restrictions or recent password changes.',
    },
})
